import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";

const DenominationDetails = () => {
    const { state } = useLocation();
    const denomination = state?.denomination;
    const navigate = useNavigate();

    if (!denomination) {
        navigate("/admin/denomination/list");
        return null;
    }

    const rows = [
        { label: "ID", value: denomination.id },
        { label: "Amount", value: denomination.amount },
        { label: "Count", value: denomination.count },
        { label: "Network ID", value: denomination.network_id ?? "-" },
        { label: "Branch Product Unit", value: denomination.branch_product_unit?.name ?? "-" },
        { label: "Created At", value: denomination.created_at },
    ];

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section
                        className="w-full pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Denomination
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Details</p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    <div className="bg-white p-6 rounded-lg shadow-sm">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-darkGreen3">
                                Denomination Details
                            </h2>
                            <Link
                                to="/admin/denomination/update"
                                state={{ denomination }}
                                className="flex items-center gap-1 text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2"
                            >
                                <PencilSquare className="w-4 h-4" />
                                Edit
                            </Link>
                        </div>

                        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {rows.map(({ label, value }) => (
                                <div key={label} className="border-b pb-2">
                                    <dt className="text-xs text-gray-500 uppercase tracking-wide">
                                        {label}
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900 font-medium">
                                        {value ?? "-"}
                                    </dd>
                                </div>
                            ))}
                        </dl>

                        <button
                            type="button"
                            onClick={() => navigate("/admin/denomination/list")}
                            className="mt-6 text-gray-700 bg-gray-200 hover:bg-gray-300 font-medium rounded-lg text-sm px-5 py-2.5"
                        >
                            Back to List
                        </button>
                    </div>
                </div>
            </MainLayouts>
        </div>
    );
};

export default DenominationDetails;
